/** Centralized React Query key factory. */

export const queryKeys = {
  documents: {
    all: ["documents"],
    detail: (id, { includeText = false } = {}) => ["documents", id, { includeText }],
  },
  documentFileUrl: (id) => ["documents", id, "fileUrl"],
  cases: {
    all: ["cases"],
    detail: (id) => ["cases", id],
  },
  conversations: (filters = {}) => ["conversations", filters],
  conversation: (id) => ["conversations", "detail", id],
  researchSessions: {
    all: ["researchSessions"],
    detail: (id) => ["researchSessions", id],
  },
  models: ["models"],
  workflows: (lang) => ["workflows", lang],
  chatPrompts: (country, lang) => ["chatPrompts", country, lang],
  draftTypes: (country) => ["draftTypes", country],
  countries: ["countries"],
  qararkStatus: ["integrations", "qarark", "status"],
};
